import { defineMessages } from 'react-intl';

export const messages: {
	bannerText: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	dismissMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	bannerText: {
		id: 'new-product-message-banner-text',
		defaultMessage: "{product} was only recently added and we're still tweaking the results.",
		description:
			'The text is shown in an informational banner on the search page when a new product has been added. The placeholder {product} will be substituted with the name of the newly added product.',
	},
	dismissMessage: {
		id: 'new-product-message-banner-dismiss-message-button',
		defaultMessage: 'Dismiss',
		description: 'Message for button to dismiss the new product banner',
	},
});
